module.exports = __webpack_public_path__ + "static/collectorcans-swarm-artwork-353ae35096c9fc6837b103dc1511eb3b.png";